import {observer} from 'mobx-react';
import Modal from 'shared/components/modals/Modal';
import ModalButtons from 'shared/components/modals/ModalButtons';
import {DragAndDrop} from 'shared/components/dnd';
import {Select2, Spinner} from 'shared/components';

const ReorderDocumentsModal = observer(({modalOpen, uiState}) => {
  const {reorderingDocuments, reorderFolder, folders, fetchingReorderingDocuments} = uiState;

  return (
    <Modal
      title='company_settings.documents.Reorder Company Documents'
      isOpen={modalOpen}
      onHide={() => uiState.closeReorderDocumentsModal()}
      size='md'
    >
      <div className='mb2'>
        <Select2
          label='company_settings.documents.Folder'
          value={reorderFolder?.id}
          onChange={e => uiState.selectReorderFolder(
            folders.find(folder => folder.id === e.target.value) || null
          )}
          allowClear
        >
          {folders.filter(folder => folder.hasDocuments).map(folder => (
            <option value={folder.id} key={folder.id}>{folder.name}</option>
          ))}
        </Select2>
      </div>
      {fetchingReorderingDocuments
        ? <Spinner/>
        : <DragAndDrop models={reorderingDocuments} component={({model}) => <div>{model.name}</div>}/>
      }
      <ModalButtons
        saveEnabled={!fetchingReorderingDocuments}
        onSave={() => uiState.saveDocumentOrders()}
        onCancel={() => uiState.closeReorderDocumentsModal()}
      />
    </Modal>
  );
});

export default ReorderDocumentsModal;
